import styled from 'styled-components/macro';

export const Section = styled.section``;

export const InfoItemList = styled.dl`
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    padding-top: 8px;
    padding-bottom: 8px;

    &.vertical {
        flex-direction: column;
    }
`;

export const InfoItemDt = styled.dt`
    font-weight: 700;
`;

export const InfoItemDd = styled.dd`
    flex: 1 1 auto;
    margin-inline-start: 10px;
`;

export const SectionHeader = styled.h2`
    font-size: 20px;
    color: #495e61;
    margin: 0;
    padding: 0 0 9px 0;
    border-bottom: 2px solid #f2f2f2;
`;

export const SectionSubHeader = styled.h3`
    font-size: 14px;
    text-transform: uppercase;
    color: #7d8a8c;
`;
